import { useNuxtApp } from "#imports";
export function useEmitter() {
  const hooks = useNuxtApp().hooks;
  return {
    emit: hooks.callHook,
    on: hooks.hook
  };
}
